module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_base_badge-5f38a89e5d810a136298ebf6b160978a.svg";